import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/publish'
)({
  component: DeploymentLayout,
})

function DeploymentLayout() {
  return (
    <div className='flex h-full flex-col'>
      <div className='flex-1 overflow-y-auto bg-muted p-8'>
        <div className='mx-auto flex max-w-[1200px] flex-col gap-8'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
